<template>
  <div class="appResponsiveHeight" v-if="token">
    <v-app :dark="!!(isDark === 'dark')" id="inspire" :class="hideContainer ? 'register-container' : 'wrapper'">
      <v-app-bar app elevate-on-scroll elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        class="custom-navbar" v-if="!$route.meta.noSidebar">
        <v-container class="fill-height app-bar-container">
          <v-app-bar-nav-icon class="d-md-none d-sm-flex d-xl-none d-lg-none"
            @click="drawer = !drawer"></v-app-bar-nav-icon>
          <audio id="notification-bell" src="sounds/notification-bell.wav" preload="auto"></audio>
          <DashboardView></DashboardView>

          <v-spacer></v-spacer>
          <div v-if="profile?.is_tutorial == 1 && tutorial_link">
            <a fab link small :href="tutorial_link" target="_blank" elevation="0"
              :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
              <v-icon color="#FF0033">mdi-youtube</v-icon>
              <span class="tutorial-text text--primary">Tutorial</span>
            </a>
          </div>
          <PanelSwitcher></PanelSwitcher>
          <!-- <SignalsView></SignalsView> -->

          <!-- <LanguageMenu></LanguageMenu> -->

          <SwitcherView></SwitcherView>

          <NotificationView></NotificationView>

          <LogoutView></LogoutView>
        </v-container>
      </v-app-bar>

      <v-container :class="hideContainer ? 'register-container-fluid' : 'custom-container'">
        <v-row no-gutters>
          <v-col xl="2" class="custom-width-navigation-drawer" v-if="!$route.meta.noSidebar">
            <div class="navigation-drawer-container">
              <v-navigation-drawer v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp" width="240"
                class="navigation-drawer sidebar-navigation-drawer"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <AdminLogo></AdminLogo>
                <AllMenu></AllMenu>
              </v-navigation-drawer>
            </div>
          </v-col>
          <v-col class="custom-width-main registration-page">
            <v-main>
              <router-view></router-view>
            </v-main>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
  <div v-else>
    <v-progress-circular indeterminate color="primary"></v-progress-circular> <!-- Loading spinner -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { PROFILE__ACTIONS } from "@/store/action-types";
import AdminLogo from "./components/SidebarTopbar/AdminLogo.vue";
import AllMenu from "./components/SidebarTopbar/AllMenu.vue";
import DashboardView from "./components/SidebarTopbar/DashboardView.vue";
import LanguageMenu from "./components/SidebarTopbar/LanguageMenu.vue";
import LogoutView from "./components/SidebarTopbar/LogoutView.vue";
import NotificationView from "./components/SidebarTopbar/NotificationView.vue";
import PanelSwitcher from "./components/SidebarTopbar/PanelSwitcher.vue";
import SignalsView from "./components/SidebarTopbar/SignalsView.vue";
import SwitcherView from "./components/SidebarTopbar/SwitcherView.vue";

export default {
  data: () => ({
    drawer: null,
  }),

  components: {
    LanguageMenu,
    NotificationView,
    SignalsView,
    SwitcherView,
    DashboardView,
    AdminLogo,
    AllMenu,
    PanelSwitcher,
    LogoutView,
  },

  watch: {
    profile: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState("authentication", ["token"]),
    ...mapState("profile", ["profile", "tutorials"]),

    tutorial_link() {
      if (Array.isArray(this.tutorials) && this.tutorials.length > 0) {
        // Get the full current route including query params
        const fullPath = this.$route.fullPath;

        // Split the fullPath into path and query string
        const [path, query] = fullPath.split('?');

        // Convert the path to kebab-case and keep the query string intact
        const currentRoute = path
          .replace(/[^a-zA-Z0-9\s-]/g, "")  // Remove special characters except for hyphens
          .trim()  // Remove leading/trailing spaces
          .replace(/\s+/g, "-")  // Replace multiple spaces with a single hyphen
          .toLowerCase();  // Ensure the case is consistent

        // Rebuild the full route with the query string
        let finalRoute = query ? `${currentRoute}?${query}` : currentRoute;

         if(!finalRoute){
          finalRoute = 'dashboard';
        }

        // Remove the "ib=" prefix from info_link if it exists
        const matchedTutorial = this.tutorials.find(tutorial => {
          const infoLink = tutorial.route.replace('ib=', '');  // Remove "ib=" from the info_link
          return infoLink === finalRoute;
        });

        return matchedTutorial ? matchedTutorial.info_link : null;
      }
      return null;
    },

    isDark() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    hideContainer() {
      return (
        this.$route.name === "CreateAccount"
      );
    },
  },

  methods: {
    ...mapActions("authentication", ["setToken"]),
    ...mapActions("profile", ["GETTUTORIALS"]),

  },

  async created() {
    await this.setToken();
    await this[PROFILE__ACTIONS.GETTUTORIALS]();
  },
};
</script>

<style scoped>
.appResponsiveHeight {
  height: 100vh;
  /* height: calc(100vh - 64px); */
  overflow-y: hidden;
  overflow-x: hidden;
}

.tutorial-text {
  margin-left: 10px;
  margin-right: 20px;
  text-decoration: underline;
  opacity: .9;
  font-weight: 300;
  font-size: 14px;
}
</style>